export const APP_TITLE = 'Bandz Journal';
export const LANDING_TITLE = 'Bandz Journal - Track Your Trades & Performance';

const MONTHS = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

// Same labels as the sidebar (src/components/navConfig.js).
const STATIC_TITLES = {
  '/': 'Calendar',
  '/trades': 'Trades',
  '/notebook': 'Notebook',
  '/notebook/graph': 'Notebook graph',
  '/summary': 'Summary',
  '/context': 'Export',
  '/visualize': 'Analytics',
  '/terminal': 'Terminal',
  '/bandzbot': 'BandzBot',
  '/checklist': 'Checklist',
  '/connections': 'Connections',
  '/connections/webull/callback': 'Connections',
  '/account-activity': 'Activity',
  '/settings': 'Settings',
  '/themes': 'Theme Studio',
  '/socials': 'Socials',
  '/feedback': 'Feedback',
  '/admin': 'Admin',
  '/edit-account': 'Edit account',
  '/quick-add': 'Quick Add',
  '/import-trades': 'Import trades',
  '/test-data': 'Test data',
  '/feature-preview': 'Feature preview',
};

function monthIndex(value) {
  const month = Number(value);
  return Number.isInteger(month) && month >= 1 && month <= 12 ? month - 1 : null;
}

function validDay(value) {
  const day = Number(value);
  return Number.isInteger(day) && day >= 1 && day <= 31 ? day : null;
}

function validYear(value) {
  return /^\d{4}$/.test(value) ? value : null;
}

/** Page name for a signed-in route, or null when there is no specific one. */
export function getRouteName(pathname = '/') {
  const path = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  if (STATIC_TITLES[path]) return STATIC_TITLES[path];

  const parts = path.split('/').filter(Boolean);
  if (parts[0] === 'month' && parts.length === 3) {
    const year = validYear(parts[1]);
    const month = monthIndex(parts[2]);
    if (year && month !== null) return `${MONTHS[month]} ${year}`;
  }
  if (parts[0] === 'day' && (parts.length === 4 || parts.length === 3)) {
    const [year, monthPart, dayPart] = parts.length === 4 ? parts.slice(1) : [null, ...parts.slice(1)];
    const month = monthIndex(monthPart);
    const day = validDay(dayPart);
    if (month !== null && day !== null) {
      const label = `${MONTHS[month].slice(0, 3)} ${day}`;
      if (parts.length === 3) return label;
      if (validYear(year)) return `${label}, ${year}`;
    }
  }
  if (parts[0] === 'edit-trade') return 'Edit trade';
  return null;
}

/** Full document title for a route. Signed-out pages keep the landing title. */
export function getDocumentTitle(pathname, { signedIn = true } = {}) {
  if (!signedIn) return LANDING_TITLE;
  const name = getRouteName(pathname);
  return name ? `${name} · ${APP_TITLE}` : APP_TITLE;
}
